// extracted by mini-css-extract-plugin
module.exports = {"itemAvatar":"CandidateAvatar_itemAvatar_1V3n2"};